import { axiosBff, AxiosResponse } from '@/plugins/axios';
import { DossierModel, PieceJointeModel } from '@/services/questionnaire/types';
import { CommentaireModel, FiltresModel } from '@/services/folders/types';
import { buildUrlWithSiret } from '@/functions/buildUrlWithSiret';

export function getDossiers(page: number, itemsPerPage: number): Promise<AxiosResponse<DossierModel[]>> {
	const url = buildUrlWithSiret('/api/acteur-dossiers', {
		page: page.toString(),
		itemsPerPage: itemsPerPage.toString()
	});
	return axiosBff.get(url);
}

export function getDossier(id: string): Promise<AxiosResponse> {
	const url = buildUrlWithSiret(`/api/details-dossier-acteur/${id}`);
	return axiosBff.get(url);
}

export function getPaginatedDossiers(
	page: number,
	itemsPerPage: number,
	filters: FiltresModel | null = null
): Promise<AxiosResponse> {
	const params: Record<string, string | null | undefined> = {
		page: page.toString(),
		itemsPerPage: itemsPerPage.toString()
	};

	if (filters && filters.echeanceStart && filters.echeanceEnd) {
		params['echeance.dateEcheanceActeurAfter'] = filters.echeanceStart;
		params['echeance.dateEcheanceActeurBefore'] = filters.echeanceEnd;
	}

	if (filters && filters.siret) {
		params['siret'] = filters.siret;
	}

	if (filters && filters.nir) {
		params['nir'] = filters.nir;
	}

	const url = buildUrlWithSiret('/api/acteur-dossiers', params);

	const additionalParams = new URLSearchParams();
	if (filters && filters.actionsType && filters.actionsType.length > 0) {
		filters.actionsType.forEach((action: string) => {
			additionalParams.append('echeance.actionActeur', action);
		});
	}

	const finalUrl = additionalParams.toString() ? `${url}&${additionalParams.toString()}` : url;

	return axiosBff.get(finalUrl, {
		headers: {
			accept: 'application/json'
		}
	});
}

export function commenterPieceDossier(payload: CommentaireModel): Promise<AxiosResponse> {
	const url = buildUrlWithSiret('/api/commentaires');
	return axiosBff.post(url, payload);
}

export function uploadFile(file: File): Promise<AxiosResponse> {
	const url = buildUrlWithSiret('/api/files/upload/qrp_attachment');
	const formData = new FormData();
	formData.append('filename', file as File);

	return axiosBff.post(url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}
	);
}

export function addFile(file: PieceJointeModel): Promise<AxiosResponse> {
	const url = buildUrlWithSiret('/api/piece_dossiers');
	return axiosBff.post(url, file);
}

export function getTypePiece(typePiece: string): Promise<AxiosResponse> {
	const url = buildUrlWithSiret('/api/type_pieces', { libelleCourt: typePiece });
	return axiosBff.get(url);
}

export function getMessagesUtilisateurs(): Promise<AxiosResponse> {
	return axiosBff.get('/api/message_utilisateurs', {
	});
}
